import React, { useMemo } from 'react';

import {
  formatShortDashDateByLanguage,
} from '../../../../services/language.utils';

import dogIcon
  from '../../../../assets/billingPayments/dog-placeholder.png';
import catIcon
  from '../../../../assets/billingPayments/cat-placeholder.png';

import { PET_TYPE } from '../../../../constants';

import './ClaimSummary.css';

const ClaimSummaryRow = ({
  leftText = '',
  rightText = '',
  rightTextBold = false,
}) => (
  <div className="File-claimbot-claim-summary-row">
    <span className="File-claimbot-claim-summary-row-left-text">
      {leftText}
    </span>

    <span
      className="File-claimbot-claim-summary-row-right-text"
      data-bold={rightTextBold}
    >
      {rightText}
    </span>
  </div>
);

const ClaimSummary = ({
  claimSummaryInfo = [],
  selectedPet = {},
}) => {
  const petIcon = useMemo(() => {
    if (selectedPet.PictureUrl) {
      return selectedPet.PictureUrl;
    }

    const petType = selectedPet.PetTypeId;

    return petType === PET_TYPE.DOG ? dogIcon : catIcon;
  }, [selectedPet]);

  return (
    <div className="File-claimbot-claim-summary-container">
      <div className="File-claimbot-claim-summary-pet-card">
        <img alt="" src={petIcon} />

        <div className="File-claimbot-claim-summary-column">
          <span className="File-claimbot-claim-summary-pet-name">
            {selectedPet.Name}
          </span>

          <span className="File-claimbot-claim-summary-pet-breed">
            {selectedPet.Breed}
          </span>
        </div>
      </div>

      <div className="File-claimbot-claim-summary-rows-container">
        {claimSummaryInfo.map((row) => {
          const key = `${row.displayName}-${row.displayValue}`;

          if (Array.isArray(row.displayValue)) {
            // there is only one step/component that allows user to
            // answer with multiple responses (array).
            const conditions = row.displayValue || [];
            return (
              <div
                key={key}
                className={'File-claimbot-claim-summary-dynamic'
                  + '-responses-container'}
              >
                <div className="File-claimbot-claim-summary-separator" />

                <ClaimSummaryRow
                  leftText="Condition"
                  rightText="Start Date"
                  rightTextBold
                />

                {conditions.map((condition) => (
                  <ClaimSummaryRow
                    key={`${condition.Date}-${condition.value}`}
                    leftText={condition.label}
                    rightText={formatShortDashDateByLanguage(condition.Date)}
                  />
                ))}

                <div className="File-claimbot-claim-summary-separator" />
              </div>
            );
          }

          return (
            <ClaimSummaryRow
              key={key}
              leftText={row.displayName}
              rightText={row.displayValue}
            />
          );
        })}
      </div>
    </div>
  );
};

export { ClaimSummary };
